// utils/estateLinks.ts — the estate deep-link triangle's ONE home in the VA
// (issue #2208, lane estate-deeplink-triangle-2026-10-01; the convention itself is
// documented in va-next's docs/features/deep-link-triangle.md, established by
// inctasoft/va-next#368). The three estate apps connect WITHOUT shared code: each app
// implements the same URL convention independently, and this module is the VA's
// implementation — the only place the outbound va-next bases and param shapes live.
//
// THE CONVENTION (VA leg, outbound to va-next):
//   mission control   https://va-next.akrsmv.net            (no focus param)
//   seat focus        https://va-next.akrsmv.net/?seat=<seat-name>  → seats plane
//   lane focus        https://va-next.akrsmv.net/?lane=<lane-id>     → board plane
// The inbound params are consumed by va-next's nav-store boot read
// (applyBootFocusParam — ?seat=<name> boots the seats plane, ?lane=<id> the board).
// Every value is percent-encoded; every link renders ONLY toward the operator-gated
// estate surface (va-next is DARK for customers by charter — no consumer exposure),
// and opens in a new browsing context (target="_blank" rel="noreferrer").
//
// THE NO-FABRICATION RULE: a ?seat=/?lane= param renders ONLY when the linking surface
// carries a real mapping — NEVER fabricated. Today's VA estate surfaces (/harness,
// /monitor) carry no seat rows and no lane ids, so they link the plain mission-control
// URL; the param builders below exist so any surface that later carries a real mapping
// links correctly. Pinned by setpoint-evals/estate-deeplink-triangle/.

/** The operator-gated va-next mission-control surface — the triangle's outbound target base. */
export const VA_NEXT_BASE = 'https://va-next.akrsmv.net';

/** vaNextUrl — the plain mission-control link (no focus param). */
export function vaNextUrl(): string {
  return VA_NEXT_BASE;
}

/** vaNextSeatUrl — deep link focusing a seat row in va-next's seats plane (?seat=<name>). */
export function vaNextSeatUrl(seatName: string): string {
  return `${VA_NEXT_BASE}/?seat=${encodeURIComponent(seatName)}`;
}

/** vaNextLaneUrl — deep link focusing a lane card in va-next's board plane (?lane=<id>). */
export function vaNextLaneUrl(laneId: string): string {
  return `${VA_NEXT_BASE}/?lane=${encodeURIComponent(laneId)}`;
}
